import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const object = casanovaObject
const form = $('.contact')

form.parsley()

form.find('select[name=subject]').on('change', function () {
  const index = $(this).find(':selected').index()
  const check = $(this).attr('data-cv') * 1
  const cvActive = index === check
  const cvRow = form.find('.cv-col')
  const cv = form.find('#cv')

  if (cvActive) {
    cvRow.slideDown().addClass('cv-col--active')
    cv.attr('name', 'cv')
    cv.prop('required', true)
  } else {
    cvRow.slideUp().removeClass('cv-col--active')
    cv.removeAttr('name')
    cv.prop('required', false)
  }
})

form.on('submit', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()

  const $form = $(this)

  const formData = new FormData(form[0])
  formData.append('action', 'casanova_contact_handler')

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    beforeSend: function () {
      $form.addClass('sending')
      Alert('warning', object.formWait, false)
    },
    success: function (res) {
      $form.removeClass('sending')

      if (res.success && res.data.redirect) {
        window.location.href = res.data.redirect
      }

      if (!res.success) {
        Alert(res.success, res.data.message)
      }
    },
  })
})
